import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/flags/ru.png'
import _imports_1 from '@/assets/flags/gb.png'


const _withScopeId = n => (_pushScopeId("data-v-06b2473c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flag-label" }, "Русский", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flag-label" }, "English", -1))

import { ref, watch } from "vue";
import { useUserStore } from "@/store/userStore";

// Define emits for this component

export default /*#__PURE__*/_defineComponent({
  __name: 'StudyLanguageToggle',
  emits: ["updateLanguage"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const store = useUserStore();
const currentLang = ref(store.selectedStudyLang);

watch(currentLang, (newLang) => {
  store.setSelectedStudyLang(newLang);
});

function updateLanguage(lang: string) {
  currentLang.value = lang;
  emit("updateLanguage");
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_btn_toggle, {
      modelValue: currentLang.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentLang).value = $event)),
      class: "custom-row",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          class: _normalizeClass([{ 'active-btn': currentLang.value === 'RU' }, "toggle-btn"]),
          value: "RU",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (updateLanguage('RU')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_0,
              class: "flag-img"
            }),
            _hoisted_1
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_v_btn, {
          class: _normalizeClass([{ 'active-btn': currentLang.value === 'EN' }, "toggle-btn"]),
          value: "EN",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (updateLanguage('EN')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_1,
              class: "flag-img"
            }),
            _hoisted_2
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})